import config from '@core/config';
import i18n from '@core/i18n';
import type { NavItem, TextLinkProps } from '@domgen/b2bce-base-ui-design-system-lib';
import { transformLinkDomain } from '@utils/links';

const { olrUrl } = config;
const t = i18n.getFixedT(null, null, 'common');

type HeaderTranslationLink = {
  text: string;
  url: string;
};

type FooterTranslationLink = {
  text: string;
  url: string;
  external?: true;
  newTab?: true;
};

export const buildHeaderLinks = (): NavItem[] => {
  const links = t('header.links', { returnObjects: true, olrUrl }) as HeaderTranslationLink[];

  return links.map(({ text, url }) => ({
    label: text,
    onClick: () => {
      window.location.href = transformLinkDomain(url);
    }
  }));
};

export const buildFooterLinks = (): TextLinkProps[] => {
  const links = t('footer.links', { returnObjects: true }) as FooterTranslationLink[];

  return links.map(({ text, url, external, newTab }) => ({
    text,
    url: !external ? transformLinkDomain(url) : url,
    target: newTab ? '_blank' : undefined
  }));
};

const tLanding = i18n.getFixedT(null, null, 'landingPage');

export const buildHeroLink = (): (() => void) => {
  const link = tLanding('hero.link', { returnObjects: true }) as { url: string };

  return () => {
    const url = transformLinkDomain(link.url);
    window.location.href = url;
  };
};

export const buildRepairLink = (): (() => void) => {
  const link = tLanding('helpSlice.repairs.link.url');

  return () => {
    const url = transformLinkDomain(link);
    window.location.href = url;
  };
};

export const buildRegisterLink = (): (() => void) => {
  const link = tLanding('helpSlice.register.link.url', { olrUrl });

  return () => {
    window.location.href = link;
  };
};
